<template>
  <div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="text-nowrap"
    >
      <span class="tags badge badge-primary">{{ typeof item === "string" ? item : item[itemKey] }}</span>
    </div>
  </div>
</template>

<script>
import 'vue-fragment'

export default {
  name: 'PillCell',
  components: {},
  props: {
    items: {
      type: [Array],
    },
    itemKey: {
      type: String,
      default: 'title',
    },
  },
}
</script>
